import { CaseStatus } from '@debbie/common/dist/cases/index.js';
import { VoucherCategory } from '@debbie/common/dist/economy/vouchers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useUpdateTypes, useUpdateTypesMap, } from '@debbie/cortex/dist/update-types/index.js';
import { useVoucherTypes } from '@debbie/cortex/dist/voucher-types/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import Button from './Button.js';
import Checkbox from './Checkbox.js';
import { PlusSquare, X } from './Icons/index.js';
import Input from './Input.js';
import Modal from './Modal.js';
import Panel from './Panel.js';
import SearchInput from './SearchInput.js';
import Table from './Table.js';
const MergeCaseRules = (props) => {
    const { rules, onChange } = props;
    const lang = useSelector((s) => s.lang);
    const updateTypesLoadable = useUpdateTypes();
    const updateTypes = h.hasData(updateTypesLoadable)
        ? updateTypesLoadable.data
        : null;
    const updateTypesMapLoadable = useUpdateTypesMap();
    const updateTypesMap = h.hasData(updateTypesMapLoadable)
        ? updateTypesMapLoadable.data
        : {};
    return (React.createElement(Panel, { header: lang.navigation.settingsCaseMergeRules },
        React.createElement("p", null, lang.caseMergeRules.description),
        React.createElement(Checkbox, { onChange: (e) => onChange({ ...rules, preventMerge: e.target.checked }), checked: rules.preventMerge, placeholder: lang.caseMergeRules.preventMerge }),
        React.createElement(Checkbox, { onChange: (e) => onChange({
                ...rules,
                hasActivePaymentPlan: e.target.checked ? null : false,
            }), checked: rules.hasActivePaymentPlan === null, placeholder: lang.caseMergeRules.hasActivePaymentPlan }),
        React.createElement(Checkbox, { onChange: (e) => onChange({
                ...rules,
                hasFoundation: e.target.checked ? null : false,
            }), checked: rules.hasFoundation === null, placeholder: lang.caseMergeRules.hasFoundation }),
        React.createElement(Checkbox, { onChange: (e) => {
                if (e.target.checked) {
                    onChange({
                        ...rules,
                        caseStatus: (rules.caseStatus || []).concat(CaseStatus.PENDING),
                    });
                }
                else {
                    onChange({
                        ...rules,
                        caseStatus: (rules.caseStatus || []).filter((status) => status !== CaseStatus.PENDING),
                    });
                }
            }, checked: (rules.caseStatus || []).includes(CaseStatus.PENDING), placeholder: lang.caseMergeRules.caseStatusPending }),
        React.createElement(Checkbox, { onChange: (e) => {
                if (e.target.checked) {
                    onChange({
                        ...rules,
                        caseStatus: (rules.caseStatus || []).concat(CaseStatus.VERIFIED),
                    });
                }
                else {
                    onChange({
                        ...rules,
                        caseStatus: (rules.caseStatus || []).filter((status) => status !== CaseStatus.VERIFIED),
                    });
                }
            }, checked: (rules.caseStatus || []).includes(CaseStatus.VERIFIED), placeholder: lang.caseMergeRules.caseStatusVerified }),
        React.createElement(Checkbox, { onChange: (e) => {
                onChange({
                    ...rules,
                    adjustVariableCaseVouchers: e.target.checked || undefined,
                });
            }, checked: rules.adjustVariableCaseVouchers, placeholder: lang.caseMergeRules.adjustVariableCaseVouchers }),
        React.createElement(CaseVoucherConstraints, { caseVoucherConstraints: rules.caseVoucherConstraints, onChange: (caseVoucherConstraints) => onChange({
                ...rules,
                caseVoucherConstraints: caseVoucherConstraints,
            }) }),
        React.createElement("h4", null, lang.caseMergeRules.doesNotHaveUpdateTypeIds),
        React.createElement(Select, { value: (rules.doesNotHaveUpdateTypeIds || []).map((updateTypeId) => {
                const updateType = updateTypesMap[updateTypeId];
                return {
                    label: lang.updateTypes[updateTypeId] ||
                        (updateType && updateType.label) ||
                        updateType,
                    value: updateTypeId,
                };
            }), isMulti: true, placeholder: lang.caseMergeRules.doesNotHaveUpdateTypeIds, classNamePrefix: "select", options: (updateTypes || []).map((updateType) => ({
                label: lang.updateTypes[updateType.updateTypeId] || updateType.label,
                value: updateType.updateTypeId,
            })), onChange: (val) => {
                const selected = val ? val.map((v) => v.value) : [];
                onChange({ ...rules, doesNotHaveUpdateTypeIds: selected });
            } }),
        React.createElement("h4", null, lang.caseMergeRules.doesHaveUpdateTypeIds),
        React.createElement(Select, { value: (rules.doesHaveUpdateTypeIds || []).map((updateTypeId) => {
                const updateType = updateTypesMap[updateTypeId];
                return {
                    label: lang.updateTypes[updateTypeId] ||
                        (updateType && updateType.label) ||
                        updateType,
                    value: updateTypeId,
                };
            }), isMulti: true, placeholder: lang.caseMergeRules.doesHaveUpdateTypeIds, classNamePrefix: "select", options: (updateTypes || []).map((updateType) => ({
                label: lang.updateTypes[updateType.updateTypeId] || updateType.label,
                value: updateType.updateTypeId,
            })), onChange: (val) => {
                const selected = val ? val.map((v) => v.value) : [];
                onChange({
                    ...rules,
                    doesHaveUpdateTypeIds: selected.length ? selected : undefined,
                });
            } })));
};
export default MergeCaseRules;
const CaseVoucherConstraints = (props) => {
    const { caseVoucherConstraints, onChange } = props;
    const lang = useSelector((s) => s.lang);
    const voucherTypesLoadable = useVoucherTypes();
    const voucherTypes = h.hasData(voucherTypesLoadable)
        ? voucherTypesLoadable.data
        : null;
    const [newModalOpen, setNewModalOpen] = useState(false);
    return (React.createElement("div", null,
        React.createElement("h4", null,
            lang.caseMergeRules.caseVoucherConstraints,
            React.createElement(PlusSquare, { style: { cursor: 'pointer', float: 'right', fontSize: '1.3em' }, onClick: () => setNewModalOpen(!newModalOpen) })),
        React.createElement("p", null, lang.caseMergeRules.caseVoucherConstraintsDescription),
        caseVoucherConstraints && (React.createElement(Table, { zebra: true }, caseVoucherConstraints.map((caseVoucherConstraint, index) => {
            const voucherType = voucherTypes?.find((voucherType) => voucherType.voucherTypeId ===
                caseVoucherConstraint.voucherTypeId);
            return (React.createElement("tr", null,
                React.createElement("td", null, 
                // @ts-ignore
                lang.economyVoucherTypeLabels[caseVoucherConstraint.voucherTypeId] || voucherType?.label),
                React.createElement("td", null, typeof caseVoucherConstraint.timeConstraintInDays ===
                    'number'
                    ? `${caseVoucherConstraint.timeConstraintInDays} ${lang.caseMergeRules.caseVoucherConstraintsDays}`
                    : lang.caseMergeRules.caseVoucherConstraintsAllDays),
                React.createElement("td", null,
                    React.createElement(X, { style: {
                            cursor: 'pointer',
                            float: 'right',
                            fontSize: '1.3em',
                        }, onClick: () => {
                            onChange(caseVoucherConstraints.filter((_, i) => i !== index));
                        } }))));
        }))),
        newModalOpen && (React.createElement(AddCaseVoucherConstraint, { onToggle: () => setNewModalOpen(!newModalOpen), onAdd: (caseVoucherConstraint) => onChange(caseVoucherConstraints
                ? caseVoucherConstraints.concat(caseVoucherConstraint)
                : [caseVoucherConstraint]), caseVoucherConstraints: caseVoucherConstraints }))));
};
const AddCaseVoucherConstraint = (props) => {
    const lang = useSelector((s) => s.lang);
    const [voucherTypeId, setVoucherTypeId] = useState(null);
    const [days, setDays] = useState('');
    const voucherTypesLoadable = useVoucherTypes();
    const voucherTypes = h.hasData(voucherTypesLoadable)
        ? voucherTypesLoadable.data
        : null;
    const selectedVoucherType = voucherTypes?.find((voucherType) => voucherType.voucherTypeId === voucherTypeId);
    const parsedDays = !Number.isNaN(parseInt(days)) ? parseInt(days) : undefined;
    console.log(typeof parsedDays, parsedDays);
    return (React.createElement(Modal, { header: lang.caseMergeRules.addCaseVoucherConstraint, onToggle: props.onToggle, maxWidth: "500px" },
        React.createElement(SearchInput, { autofocus: true, searchAll: (q) => {
                const results = ((!q
                    ? voucherTypes
                    : voucherTypes?.filter((voucherType) => (JSON.stringify(voucherType) +
                        lang.economyVoucherTypeLabels[voucherType.voucherTypeId])
                        .toLocaleLowerCase()
                        .includes(q.toLocaleLowerCase()))) || [])
                    ?.filter((voucherType) => [VoucherCategory.COST, VoucherCategory.COURTCOST].includes(
                // @ts-ignore
                voucherType.category) &&
                    !(props.caseVoucherConstraints || []).find((constraint) => constraint.voucherTypeId === voucherType.voucherTypeId))
                    .map((voucherType) => ({
                    key: voucherType.voucherTypeId,
                    heading: lang.economyVoucherTypeLabels[voucherType.voucherTypeId] ||
                        voucherType?.label,
                    // @ts-ignore
                    subheading: lang.economyCategories[voucherType.category],
                    returnData: voucherType.voucherTypeId,
                }));
                return results;
            }, onSelect: (voucherTypeId) => {
                setVoucherTypeId(voucherTypeId);
            }, onRemoveStatic: () => setVoucherTypeId(null), placeholder: lang.caseMergeRules.addCaseVoucherConstraintSelectVoucherType, static: selectedVoucherType
                ? lang.economyVoucherTypeLabels[selectedVoucherType.voucherTypeId] || selectedVoucherType?.label
                : undefined }),
        React.createElement(Input, { placeholder: lang.caseMergeRules.addCaseVoucherConstraintUniqueInDays, onChange: (e) => setDays(e.target.value), value: days || '', type: "number" }),
        React.createElement(Button, { block: true, disabled: !voucherTypeId, onClick: () => {
                props.onAdd({
                    voucherTypeId: voucherTypeId,
                    timeConstraintInDays: typeof parsedDays === 'number' ? parsedDays : undefined,
                });
                props.onToggle();
            } }, lang.caseMergeRules.addCaseVoucherConstraintAddButton)));
};
//# sourceMappingURL=MergeCaseRules.js.map